import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';

export interface AppConfirmData {
  title: string;
  message: string;
  instructions?: string;
  okText?: string;
  cancelText?: string;
  extraButton?: {
    text: string;
  };
  width?: string;
}

@Component({
  selector: ' ebo-app-confirm',
  template: `<h1 matDialogTitle>{{ data.title }}</h1>
    <div mat-dialog-content>
      <p>{{ data.message }}</p>
      <p *ngIf="data.instructions">
        <strong>{{ data.instructions }}</strong>
      </p>
    </div>
    <div mat-dialog-actions [class.three-buttons]="data.extraButton">
      <button type="button" mat-raised-button color="primary" (click)="dialogRef.close(true)">
        {{ data.okText || 'Ok' }}
      </button>
      <button *ngIf="data.extraButton" type="button" mat-raised-button color="primary" (click)="dialogRef.close('extra')">
        {{ data.extraButton.text }}
      </button>
      <button type="button" color="accent" mat-raised-button (click)="dialogRef.close(false)">
        {{ data.cancelText || 'Cancel' }}
      </button>
    </div>`,
  styles: [
    `
      .mat-mdc-dialog-container {
        max-width: 90vw;
        width: 500px;
      }
    `
  ]
})
export class AppComfirmComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<AppComfirmComponent>, @Inject(MAT_DIALOG_DATA) public data: AppConfirmData) {}
  ngOnInit(): void {}
}
